<template>
  <div class="ldgl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="关键字">
              <el-input v-model="search" placeholder="关键字搜索" style="width: 230px;" @keyup.enter.native="Search"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addTemplate">添加模板</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    label="品牌"
                    width="90"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.bid===1">乔金斯</span>
                      <span v-if="scope.row.bid===3">首造</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="模板名称"
                    min-width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span title="点击下载" style="color:#409EFF;font-weight: 500;" @click="downLoad(scope.row)">{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上传人"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.uploadName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上传时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button :disabled="(user.dGroupid===1&&scope.row.bid!==3)||(user.dGroupid===2&&scope.row.bid!==1)" icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                      <el-button :disabled="(user.dGroupid===1&&scope.row.bid!==3)||(user.dGroupid===2&&scope.row.bid!==1)" icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      top="20vh"
      width="40%">
      <el-form size="small" label-width="80px" :model="addForm" :rules="addRules">
        <el-form-item label="品牌" prop="bid">
          <el-select v-model="addForm.bid" placeholder="请选择">
            <el-option label="乔金斯" v-if="user.dGroupid===2" :value="1"></el-option>
            <el-option label="首造" v-if="user.dGroupid===1" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="addForm.name" size="small" type="text" placeholder="请输入模板名称" maxlength="15" show-word-limit/>
        </el-form-item>
        <el-form-item label="上传文件" prop="fileid">
          <SingleFile :key="addForm.key" v-model="addForm.fileid" :accept="'.xls'" :old="oldFile" :tip="'只能上传Excel'" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="btnLoading" icon="el-icon-check" type="primary" @click="submitTemplate">提交</el-button>
          <el-button icon="el-icon-close" @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getMaterialTemplate, addOrEditMaterialTemplate, deleteMaterialTemplate } from '@/api/erp'
import SingleFile from '../../../components/upload/SingleFile'

export default {
  name: 'ldmb',
  components: {
    SingleFile
  },
  data() {
    return {
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      addForm: {
        id: 0,
        name: '',
        bid: null,
        fileid: '',
        key: new Date().getTime.toString()
      },
      oldFile: [],
      addRules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { max: 15, message: '长度小于15个字符', trigger: 'blur' }
        ],
        bid: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        fileid: [
          { required: true, message: '请上传模板', trigger: 'change' }
        ]
      },
      dialogTitle: '',
      dialogVisible: false,
      btnLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        name: this.search,
      }
      this.loading = true
      getMaterialTemplate(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    downLoad(row) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', row.url, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = row.fileName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${row.fileName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
      this.btnLoading = false
    },
    addTemplate() {
      this.addForm.id = 0
      this.addForm.name = ''
      this.addForm.fileid = ''
      this.addForm.key = new Date().getTime().toString()
      this.oldFile = []
      this.addForm.bid = null
      this.dialogTitle = '添加模板'
      this.dialogVisible = true
    },
    editTemplate(row) {
      this.addForm.id = row.mtid
      this.addForm.name = row.name
      this.addForm.fileid = row.fileid
      this.addForm.bid = row.bid
      this.oldFile = [{ id: row.fileid, name: row.fileName }]
      this.addForm.key = new Date().getTime().toString()
      this.dialogTitle = '修改模板'
      this.dialogVisible = true
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除这条记录吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        const data = {
          id: row.mtid
        }
        deleteMaterialTemplate(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {
      })
    },
    submitTemplate() {
      const data = {
        userid: this.user.dUserid,
        fileid: this.addForm.fileid,
        name: this.addForm.name,
        id: this.addForm.id,
        bid: this.addForm.bid
      }
      this.btnLoading = true
      addOrEditMaterialTemplate(data).then(response => {
        this.$message({
          message: response.msg,
          type: 'success'
        })
        this.btnLoading = false
        this.dialogVisible = false
        this.getData()
      }).catch(() => {
        this.btnLoading = false
      })
    },
    Search() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.pageSize = 1
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.ldgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
